import { directories } from './directories';

export default directories;
